"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _utils = require("./utils");

var _item = require("./item.js");

var _group = require("./group.js");

var _strip = require("./strip.js");

var _column = require("./column.js");

var _layoutsStore = _interopRequireDefault(require("./layoutsStore.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Layouter = /*#__PURE__*/function () {
  function Layouter(layoutParams) {
    this.ready = false;
    this.pointer = 0;
    this.layoutItems = [];
    this.findNeighborItem = this.findNeighborItem.bind(this);
    this.updateParams(layoutParams);

    if (this.createLayoutOnInit !== false) {
      this.createLayout(layoutParams);
    }
  }

  var _proto = Layouter.prototype;

  _proto.updateParams = function updateParams(layoutParams) {
    this.srcItems = layoutParams.items;
    this.styleParams = _utils.utils.convertStyleParams(layoutParams.styleParams);
    this.container = _utils.utils.convertContainer(layoutParams.container, this.styleParams);
    var options = layoutParams.options || {};
    this.useExistingLayout = !!options.useExistingLayout;
    this.createLayoutOnInit = options.createLayoutOnInit;
    this.showAllItems = !!options.showAllItems || !!layoutParams.showAllItems;
    this.skipVisibilitiesCalc = !!options.skipVisibilitiesCalc;
    this.useLayoutStore = !!options.useLayoutStore;
  };

  _proto.verifyGalleryState = function verifyGalleryState() {
    if (!this.container.galleryWidth) {
      this.ready = false;
      this.reason = 'galleryWidth is undefined or 0';
      return false;
    }

    if (!this.styleParams.gallerySize) {
      this.ready = false;
      this.reason = 'gallerySize is undefined or 0';
      return false;
    }

    return true;
  };

  _proto.calcNumberOfColumns = function calcNumberOfColumns(galleryWidth, gallerySize) {
    var numOfCols = 1;

    if (this.styleParams.isVertical) {
      if (this.styleParams.fixedColumns > 0) {
        numOfCols = this.styleParams.fixedColumns;
      } else if (this.styleParams.columnWidths) {
        numOfCols = this.styleParams.columnWidths.split(',').length;
      } else {
        numOfCols = Math.ceil(galleryWidth / gallerySize) || 1;
      }
    } else {
      numOfCols = 1;
    }

    return numOfCols;
  };

  _proto.findShortestColumn = function findShortestColumn(columns, groupIdx) {
    var minCol = columns[0];

    if (this.styleParams.placeGroupsLtr) {
      minCol = columns[groupIdx % columns.length];
    } else {
      var minColH = -1;

      for (var _iterator = _createForOfIteratorHelperLoose(columns), _step; !(_step = _iterator()).done;) {
        var column = _step.value;
        var colH = column.height;

        if (colH < minColH || minColH < 0) {
          minColH = colH;
          minCol = column;
        }
      }
    }

    return minCol;
  };

  _proto.saveExistingLayout = function saveExistingLayout() {
    if (this.useLayoutStore) {
      _layoutsStore["default"].layout = {
        pointer: this.pointer,
        layoutItems: this.layoutItems,
        groups: this.groups,
        strips: this.strips,
        groupIdx: this.groupIdx,
        groupItems: this.groupItems,
        group: this.group,
        strip: this.strip,
        gallerySize: this.gallerySize,
        galleryHeight: this.galleryHeight,
        columns: this.columns
      };
    }
  };

  _proto.prepareLayoutParams = function prepareLayoutParams() {
    var _this = this;

    if (this.useExistingLayout && this.pointer > 0) {
      if (this.useLayoutStore) {
        Object.assign(this, _layoutsStore["default"].layout);
      } else {
        if (this.styleParams.isVertical) {
          //---------------------| COLUMNS GALLERY |----------------------//
          //remove items from the last 3 groups;
          var lastGroups = this.groups.slice(-3);
          lastGroups.forEach(function (group) {
            var column = _this.columns[group.columnIdx];

            if (column) {
              column.height -= group.totalHeight;
              column.groups.splice(-1, 1);
            }

            _this.groups.splice(-1, 1);

            group.items.forEach(function () {
              _this.layoutItems.splice(-1, 1);

              _this.pointer--;
            });
            _this.groupIdx--;
          });
        } else {
          //---------------------| STRIPS GALLERY |----------------------//
          //remove items from the last 2 strips;
          var lastStrips = this.strips.slice(-2);

          if (lastStrips) {
            lastStrips.forEach(function (lastStrip) {
              if (lastStrip) {
                _this.strips.splice(-1, 1);

                var groups = lastStrip.groups;
                groups.forEach(function (group) {
                  _this.groups.splice(-1, 1);

                  group.items.forEach(function () {
                    _this.layoutItems.splice(-1, 1);

                    _this.pointer--;
                  });
                  _this.groupIdx--;
                });
              }
            });
            this.galleryHeight = this.strips.reduce(function (totalHeight, strip) {
              return totalHeight += strip.height;
            }, 0); // this.strip = this.strips[this.strips.length - 1];

            this.strip = new _strip.Strip({
              idx: this.strips.length,
              container: this.container,
              groupsPerStrip: this.styleParams.groupsPerStrip,
              oneRow: this.styleParams.oneRow,
              gallerySize: this.gallerySize
            });
          }
        }

        this.groupItems = [];
      }

      this.item = {};
      this.maxLoops = this.srcItems.length * 10;
    } else {
      this.pointer = 0;
      this.firstGroup = false;
      this.layoutItems = [];
      this.groups = [];
      this.strips = [];

      if (this.styleParams.forceFullHeight) {
        this.gallerySize = Math.sqrt(this.container.galleryHeight * this.container.galleryWidth / this.srcItems.length);
      } else {
        var gallerySizeVal;

        if (typeof this.styleParams.gallerySize === 'function') {
          gallerySizeVal = this.styleParams.gallerySize();
        } else {
          gallerySizeVal = this.styleParams.gallerySize;
        }

        this.gallerySize = Math.floor(gallerySizeVal) + Math.ceil(2 * (this.styleParams.imageMargin - this.styleParams.galleryMargin));
      }

      this.galleryWidth = Math.floor(this.container.galleryWidth);
      this.maxGroupSize = this.getMaxGroupSize();
      this.groupIdx = 0;
      this.item = {};
      this.groupItems = [];
      this.group = {};
      this.bounds = this.container.bounds || {};
      this.strip = new _strip.Strip({
        idx: 1,
        container: this.container,
        groupsPerStrip: this.styleParams.groupsPerStrip,
        oneRow: this.styleParams.oneRow,
        gallerySize: this.gallerySize
      });
      this.galleryHeight = 0;
      this.numOfCols = this.calcNumberOfColumns(this.galleryWidth, this.gallerySize);
      this.gallerySize = this.styleParams.isVertical ? Math.floor(this.galleryWidth / this.numOfCols) : this.gallerySize;
      var _this$styleParams = this.styleParams,
          columnWidths = _this$styleParams.columnWidths,
          cubeRatio = _this$styleParams.cubeRatio;
      var columnWidthsArr = columnWidths && columnWidths.length > 0 ? columnWidths.split(',') : false;
      this.columns = Array(this.numOfCols).fill(0).map(function (column, idx) {
        return new _column.Column(idx, columnWidthsArr ? columnWidthsArr[idx] : _this.gallerySize, _this.styleParams.cubeRatio);
      });
      this.columns[this.numOfCols - 1].width += this.galleryWidth - this.columns.reduce(function (sum, col) {
        return col.width + sum;
      }, 0); //the last group compensates for half pixels in other groups

      this.columns[this.numOfCols - 1].cubeRatio = cubeRatio * (this.columns[this.numOfCols - 1].width / this.gallerySize); //fix the last group's cube ratio

      this.maxLoops = this.srcItems.length * 10;
    }
  };

  _proto.createLayout = function createLayout(layoutParams) {
    if (typeof layoutParams !== 'undefined') {
      this.updateParams(layoutParams);
    }

    if (!this.verifyGalleryState()) {
      return false;
    }

    this.prepareLayoutParams();

    while (this.srcItems[this.pointer]) {
      if (this.imagesLeft === 6) {
        this.saveExistingLayout();
      }

      this.maxLoops--;

      if (this.maxLoops <= 0) {
        console.error('Cannot create layout, maxLoops reached!!!');
        return false;
      }

      this.item = new _item.Item({
        idx: this.pointer,
        inGroupIdx: this.groupItems.length + 1,
        scrollTop: this.galleryHeight,
        dto: this.srcItems[this.pointer],
        container: this.container,
        styleParams: this.styleParams
      });
      this.layoutItems[this.pointer] = this.item; //push the image to a group - until its full

      this.groupItems.push(this.item);

      if (this.groupItems.length < this.maxGroupSize && this.srcItems[this.pointer + 1]) {
        this.pointer++;
        continue;
      }

      this.group = new _group.Group({
        idx: this.groupIdx,
        stripIdx: this.strip.idx,
        inStripIdx: this.strip.groups.length + 1,
        top: this.galleryHeight,
        items: this.groupItems,
        isLastItems: this.isLastImages,
        gallerySize: this.gallerySize,
        showAllItems: this.showAllItems,
        container: this.container,
        styleParams: this.styleParams
      });
      this.groups[this.groupIdx] = this.group; //take back the pointer in case the group was created with less items

      this.pointer += this.group.realItems.length - this.groupItems.length;
      this.groupIdx++;
      this.groupItems = []; //resize and fit the group in the strip / column

      if (!this.styleParams.isVertical) {
        //---------------------| STRIPS GALLERY |----------------------//
        if (this.strip.isFull(this.group, this.isLastImage)) {
          //close the current strip
          this.strip.resizeToHeight(this.galleryWidth / this.strip.ratio);
          this.strip.setWidth(this.galleryWidth);
          this.galleryHeight += this.strip.height;
          this.columns[0].addGroups(this.strip.groups);
          this.strips.push(this.strip); //open a new strip

          this.strip = new _strip.Strip({
            idx: this.strip.idx + 1,
            container: this.container,
            groupsPerStrip: this.styleParams.groupsPerStrip,
            oneRow: this.styleParams.oneRow,
            gallerySize: this.gallerySize
          }); //reset the group (this group will be rebuilt)

          this.pointer -= this.group.realItems.length - 1;
          this.groupIdx--;
          continue;
        } //add the group to the (current/new) strip


        this.group.setTop(this.galleryHeight);
        this.strip.ratio += this.group.ratio; // this.strip.height = Math.min(gallerySize, (galleryWidth / this.strip.ratio));

        this.strip.height = this.galleryWidth / this.strip.ratio;
        this.strip.setWidth(this.galleryWidth);
        this.strip.addGroup(this.group);

        if (this.isLastImage && this.strip.hasGroups) {
          if (this.styleParams.oneRow) {
            this.strip.height = this.container.galleryHeight + (this.styleParams.imageMargin - this.styleParams.galleryMargin);
          } else if (this.gallerySize * 1.5 < this.strip.height) {
            //stretching the this.strip to the full width will make it too high - so make it as high as the gallerySize and not stretch
            this.strip.height = this.gallerySize;
            this.strip.markAsIncomplete();
          }

          this.strip.resizeToHeight(this.strip.height);
          this.galleryHeight += this.strip.height;
          this.columns[0].addGroups(this.strip.groups);
          this.strips.push(this.strip);
        }
      } else {
        //---------------------| COLUMNS GALLERY |----------------------//
        //find the shortest column
        var minCol = this.findShortestColumn(this.columns, this.groups.length - 1); //resize the group and images

        this.group.fixItemsRatio(minCol.cubeRatio); //fix last column's items ratio (caused by stretching it to fill the screen)

        this.group.resizeToWidth(minCol.width);
        this.group.round(); //update the group's position

        this.group.setTop(minCol.height);
        this.group.setLeft(minCol.idx * this.gallerySize); //add the image to the column

        minCol.addGroup(this.group); //add the image height to the column

        minCol.height += this.group.totalHeight;

        if (this.galleryHeight < minCol.height) {
          this.galleryHeight = minCol.height;
        }
      } //set the group visibility


      if (!this.skipVisibilitiesCalc && !this.gotScrollEvent && this.pointer < 10) {
        //until the first scroll event, make sure the first 10 groups are displayed
        this.group.calcVisibilities(true);
      } else {
        this.group.calcVisibilities(this.bounds);
      }

      if (!this.firstGroup) {
        this.firstGroup = this.group;
      }

      this.pointer++;
    }

    if (this.styleParams.forceFullHeight) {
      var stretchRatio = this.container.galleryHeight / this.galleryHeight;
      this.items.map(function (item) {
        item.cubeImages = true;
        item.cubeRatio = item.ratio = item.width / (item.height * stretchRatio);
        item.height *= stretchRatio;
        return item;
      });
      this.groups.map(function (group) {
        group.height *= stretchRatio;
        group.setTop(group.top * stretchRatio);
        group.resizeItems();
        return group;
      });
    } //results


    this.lastGroup = this.group;
    this.colWidth = Math.floor(this.galleryWidth / this.numOfCols);
    this.height = this.galleryHeight - (this.styleParams.imageMargin - this.styleParams.galleryMargin) * 2;

    if (!this.skipVisibilitiesCalc) {
      this.calcVisibilities(this.bounds);
    }

    this.ready = true;
    return this.scheme;
  };

  _proto.calcVisibilities = function calcVisibilities(bounds) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.columns), _step2; !(_step2 = _iterator2()).done;) {
      var column = _step2.value;

      for (var _iterator3 = _createForOfIteratorHelperLoose(column.groups), _step3; !(_step3 = _iterator3()).done;) {
        var group = _step3.value;
        group.calcVisibilities(bounds);
      }
    }

    return this.scheme;
  };

  _proto.lastVisibleItemIdxInHeight = function lastVisibleItemIdxInHeight(height) {
    for (var i = this.items.length - 1; i >= 0; i--) {
      var item = this.items[i];
      var isVisible = item.offset.top < height;

      if (isVisible) {
        return i;
      }
    }

    return this.items.length - 1;
  };

  _proto.lastVisibleItemIdx = function lastVisibleItemIdx() {
    //the item must be visible and about the show more button
    return this.lastVisibleItemIdxInHeight(this.container.galleryHeight - 100);
  };

  _proto.findNeighborItem = function findNeighborItem(itemIdx, dir) {
    var _this2 = this;

    var currentItem = this.layoutItems[itemIdx];
    var neighborItem;

    var findClosestItem = function findClosestItem(currentItemX, currentItemY, condition) {
      var minDistance = null;
      var minDistanceItem = {};
      var itemY;
      var itemX;
      var distance; // each(slice(this.layoutItems, itemIdx - 50, itemIdx + 50), (item) => {

      _this2.layoutItems.forEach(function (item) {
        itemY = item.offset.top + item.height / 2;
        itemX = item.offset.left + item.width / 2;
        distance = Math.sqrt(Math.pow(itemY - currentItemY, 2) + Math.pow(itemX - currentItemX, 2));

        if ((minDistance === null || distance > 0 && distance < minDistance) && condition(currentItemX, currentItemY, itemX, itemY)) {
          minDistance = distance;
          minDistanceItem = item;
        }
      });

      return minDistanceItem;
    };

    switch (dir) {
      case 'up':
        neighborItem = findClosestItem(currentItem.offset.left + currentItem.width / 2, currentItem.offset.top, function (curX, curY, itmX, itmY) {
          return itmY < curY;
        });
        break;

      case 'left':
        neighborItem = findClosestItem(currentItem.offset.left, currentItem.offset.top + currentItem.height / 2, function (curX, curY, itmX) {
          return itmX < curX;
        });
        break;

      case 'down':
        neighborItem = findClosestItem(currentItem.offset.left + currentItem.width / 2, currentItem.offset.bottom, function (curX, curY, itmX, itmY) {
          return itmY > curY;
        });
        break;

      default:
      case 'right':
        neighborItem = findClosestItem(currentItem.offset.right, currentItem.offset.top + currentItem.height / 2, function (curX, curY, itmX) {
          return itmX > curX;
        });
        break;
    }

    if (neighborItem.idx >= 0) {
      return neighborItem.idx;
    } else {
      console.warn('Could not find offset for itemIdx', itemIdx, dir);
      return itemIdx; //stay on the same item
    }
  };

  _proto.getMaxGroupSize = function getMaxGroupSize() {
    var _maxGroupSize = 1;

    try {
      var groupTypes = typeof this.styleParams.groupTypes === 'string' && this.styleParams.groupTypes.length > 0 ? this.styleParams.groupTypes.split(',') : this.styleParams.groupTypes;
      _maxGroupSize = groupTypes.reduce(function (curSize, groupType) {
        return Math.max(curSize, parseInt(groupType));
      }, 1);
      _maxGroupSize = Math.min(_maxGroupSize, this.styleParams.groupSize);
    } catch (e) {
      console.error("couldn't calculate max group size - returing 3 (?)", e);
      _maxGroupSize = 3;
    }

    return _maxGroupSize;
  };

  _createClass(Layouter, [{
    key: "isLastImage",
    get: function get() {
      return !this.srcItems[this.pointer + 1];
    }
  }, {
    key: "isLastImages",
    get: function get() {
      if (this.styleParams.layoutsVersion > 1) {
        //layouts version 2+
        return !this.srcItems[this.pointer + 1];
      } else {
        //Backwards compatibility
        return !this.srcItems[this.pointer + 3];
      }
    }
  }, {
    key: "imagesLeft",
    get: function get() {
      return this.srcItems.length - this.pointer - 1;
    }
  }, {
    key: "items",
    get: function get() {
      return this.layoutItems;
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        items: this.items.map(function (item) {
          return item.scheme;
        }),
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        strips: this.strips.map(function (strip) {
          return strip.scheme;
        }),
        columns: this.columns.map(function (column) {
          return column.scheme;
        }),
        height: this.height
      };
    }
  }]);

  return Layouter;
}();

exports["default"] = Layouter;